import { createSlice } from '@reduxjs/toolkit';
import { ClaimsUpdateStateType } from '../../types/claimsUpdate';

const initialState: ClaimsUpdateStateType = {
    loading: false,
    loadingMultiple: false
};
export const claimsUpdateSlice = createSlice({
    name: 'claimsUpdate',
    initialState,
    reducers: {
        patchClaimFetch: (state, action) => {
            state.loading = true;
        },
        patchClaimFetchSuccess: (state) => {
            state.loading = false;
        },
        patchClaimFetchFailure: (state, action) => {
            state.loading = false;
        },
        patchMultipleClaimsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        patchMultipleClaimsFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        patchMultipleClaimsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        }
    }
});

export const {
    patchClaimFetch,
    patchClaimFetchSuccess,
    patchClaimFetchFailure,
    patchMultipleClaimsFetch,
    patchMultipleClaimsFetchSuccess,
    patchMultipleClaimsFetchFailure,
} = claimsUpdateSlice.actions;

export default claimsUpdateSlice.reducer;
